import { render, staticRenderFns } from "./JobsRenewalReasonsCountCard.vue?vue&type=template&id=7d19b57c&"
import script from "./JobsRenewalReasonsCountCard.vue?vue&type=script&lang=js&"
export * from "./JobsRenewalReasonsCountCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports